import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { GlobalProgressBarInterceptor } from '../interceptors';

export function provideGlobalProgressBar(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: HTTP_INTERCEPTORS,
      useClass: GlobalProgressBarInterceptor,
      multi: true,
    },
  ]);
}
